import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/chart-of-accounts',
    name: 'chart-of-account',
    meta: { middleware: authenticate },
    component: () => import('@/pages/accounting/chart-of-account/index.vue')
  },
  {
    path: '/chart-of-accounts/create',
    name: 'chart-of-account-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/accounting/chart-of-account/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('accounting/chartOfAccount/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/chart-of-accounts/:id',
    name: 'chart-of-account-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/accounting/chart-of-account/edit.vue'),
    props: route => ({ chartOfAccount: route.params.chartOfAccount }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('accounting/chartOfAccount/dataBeforeCreate')
      let response = await store.dispatch('accounting/chartOfAccount/find', to.params.id)
      let { account_type, parent_account, ...resource } = response.data
      to.params.chartOfAccount = resource
      next()
    }
  }
]
